/**
 * Smoke Drive panel entry. Browser UI lives in operatorMessages/OperatorDrivePanel.js
 * (same module as before this wave) so existing imports stay stable.
 */
export { default } from '../operatorMessages/OperatorDrivePanel';
